module.exports = __webpack_public_path__ + "img/speaker.bb1c5875.svg";